import script from "./ViewLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLogin.vue?vue&type=script&setup=true&lang=js"

import "./ViewLogin.vue?vue&type=style&index=0&id=cce8a8d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cce8a8d2"]])

export default __exports__